export const DEFAULT_API_TOKEN = 'public'
export const DEFAULT_PRIMARY_COLOR = '#1677ff'
export const ETIKET_URUN_ID = 201156
export const KITAP_KAPLAMA_DERS_ID = 38
export const KITAP_KAPLAMA_URUN_ID = 577
export const KIRTASIYE_KATEGRI_ID = 2125
export const LISTE_DISI_URUNLER_KATEGORI_ID = 2158
export const DEV_BACKEND_DOMAIN = 'okulsepeti.com.tr'
